import React, { useState } from 'react';
import styles from './index.module.scss';
import CategoriesDropwdown from 'components/CategoriesDropwdown';
import InventoryItemUnitDropwdown from 'components/InventoryItemUnitDropdown';
import { showError, showSuccess } from 'utils';
import { createCalculatedInventoryItem } from 'services';
import { useEffect } from 'react';

const AddCalculatedItemModal = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const [name, setName] = useState<string>('');
  const [englishName, setEnglishName] = useState<string>('');
  const [multiplier, setMultiplier] = useState<number>();
  const [price, setPrice] = useState<number>(0);
  const [unitId, setUnitId] = useState<string>('');
  const [categoryId, setCategoryId] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [englishDescription, setEnglishDescription] = useState<string>('');
  const { parentItemDetails, onSuccess, toggleModal } = props;

  const addCalculatedItem = async () => {
    setLoading(true);
    const data = {
      name,
      enName: englishName,
      parentItemId: parentItemDetails.objectId,
      multiplier,
      price,
      unitId,
      categoryId,
      description,
      enDescription: englishDescription,
    };
    try {
      await createCalculatedInventoryItem(data);
      await onSuccess();
      toggleModal();
      showSuccess('Calculated Item added successfully');
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{
    if(parentItemDetails){
      setName(parentItemDetails.name);
      setDescription(parentItemDetails.description);
      setEnglishName(parentItemDetails.enName);
      setEnglishDescription(parentItemDetails.enDescription);
    }
  },[parentItemDetails]);

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Inventory Item</div>
            <div className={styles['modal-title']}>Add Calculated Item</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Name</div>
            <input
              disabled={loading}
              className={'form-control'}
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </div>
          <div className={styles['input-group']}>
            <div className={styles['label']}>English Name</div>
            <input
              disabled={loading}
              className={'form-control'}
              value={englishName}
              onChange={e => setEnglishName(e.target.value)}
            />
          </div>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Multiplier</div>
            <input
              type={'number'}
              value={multiplier || ''}
              disabled={loading}
              className={'form-control'}
              onChange={e => setMultiplier(parseInt(e.target.value))}
            />
          </div>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Price</div>
            <input
              type={'number'}
              disabled={loading}
              className={'form-control'}
              onChange={e => setPrice(parseFloat(e.target.value))}
            />
          </div>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Unit</div>
            <InventoryItemUnitDropwdown
              loading={loading}
              value={unitId}
              onSelect={(objectId) => setUnitId(objectId)}
            />
          </div>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Category</div>
            <CategoriesDropwdown
              disabled={loading}
              value={categoryId}
              onSelect={({ objectId }) => setCategoryId(objectId)}
            />
          </div>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Description</div>
            <textarea
              disabled={loading}
              className={'form-control'}
              value={description}
              onChange={e => setDescription(e.target.value)}
            />
          </div>
          <div className={styles['input-group']}>
            <div className={styles['label']}>English Description</div>
            <textarea
              disabled={loading}
              className={'form-control'}
              value={englishDescription}
              onChange={e => setEnglishDescription(e.target.value)}
            />
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={addCalculatedItem}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddCalculatedItemModal;
